exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marker_detail[data-v-209fa67e]{bottom:3%;right:3%;padding:10px;height:260px;width:450px}.close_icon[data-v-209fa67e]{top:26px;right:26px}[data-v-209fa67e] .el-card__body,[data-v-209fa67e] .el-card__header{background-color:#fff}[data-v-209fa67e] .el-card .el-card__body{padding:20px}", ""]);

// exports
